import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BaseTag from "@/components_v2/Tags/BaseTag";
import { TAG_VARIANTS } from "@/components_v2/Tags/constants";
import {
  certificationPaths,
  certificationRouteKey,
} from "@/domains/certifications/routes";
import { getModuleVideoMeta } from "@/domains/certifications/utils";
import { ModuleHeaderProps } from "@/features/certifications/module/components/types";

import "./styles.css";

const ModuleHeader = ({
  certification,
  week,
  pathTitle,
  questionCount,
}: ModuleHeaderProps) => {
  const { t } = useTranslation();
  const weekLabel = t("certification.labels.week", {
    position: week.position,
  });
  const meta = [
    getModuleVideoMeta(t, week.module),
    questionCount
      ? t("certification.module.questionCount", { count: questionCount })
      : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <header className="flex flex-col gap-400">
      <nav
        className="flex items-center gap-250"
        aria-label={t("certification.module.breadcrumb")}
      >
        <Link
          to={certificationPaths.overview(certificationRouteKey(certification))}
          className="module-breadcrumb-link"
        >
          {certification.title}
        </Link>

        <span className="certification-muted body-s-regular" aria-hidden>
          ›
        </span>

        <span
          className="certification-muted body-s-regular"
          aria-current="page"
        >
          {weekLabel}
        </span>
      </nav>

      <div className="flex flex-col gap-200">
        <div className="flex items-center gap-300">
          <span className="module-eyebrow body-xs-regular">{weekLabel}</span>

          <BaseTag
            label={pathTitle}
            size="small"
            variant={TAG_VARIANTS.TINTED}
          />
        </div>

        <h1 className="certification-title">{week.module.title}</h1>

        <p className="certification-muted body-s-regular">{meta}</p>
      </div>
    </header>
  );
};

export default ModuleHeader;
